<div class="dialog-container">
  <h1 class="dialog-title">{{ 'PRESENTER.ITEM_TABLE_TOOLS.EXCLUDED_ITEMS.TITLE' | translate }}</h1>

  @if (vm$ | async; as vm) {
    @if (!vm.loaded && vm.items.length === 0) {
      <div class="loading">
        <mat-progress-spinner mode="indeterminate" diameter="32"></mat-progress-spinner>
      </div>
    } @else if (vm.items.length === 0) {
      <div class="empty-state">{{ 'PRESENTER.ITEM_TABLE_TOOLS.EXCLUDED_ITEMS.EMPTY' | translate }}</div>
    } @else {
      <div class="items-table">
        <gb-table
          [inDialog]="true"
          [enableSelect]="false"
          [tableData$]="tableData$"
          [displayedColumns$]="getDisplayedColumns$(itemType)"
          [loaded$]="loaded$"
          [totalItemCount]="vm.items.length"
        ></gb-table>
      </div>

      <div class="actions">
        <button mat-flat-button type="button" (click)="close()">
          {{ 'CLOSE' | translate }}
        </button>
      </div>
    }
  }
</div>

<ng-template #itemType let-data>
  <gb-item-type-chip [item]="data.item"></gb-item-type-chip>
</ng-template>
